import { Injectable } from '@angular/core';

const LOCAL_STORAGE_KEY = 'oauthStates';

@Injectable({
  providedIn: 'root'
})
export class SsoOauthStateService {
  public storeState(state: string) {
    const stateObject: StateObject = {
      state: state,
      time: Date.now()
    };

    const oauthStatesItem = localStorage.getItem(LOCAL_STORAGE_KEY);
    let oauthStates: StateObject[] | null = oauthStatesItem ? JSON.parse(oauthStatesItem) : null;
    if (oauthStates) {
      // Cleanup states that are older than 1 hour
      const stateMaxAgeInMillis = 1000 * 60 * 60;
      const maxTimestamp = Date.now() - stateMaxAgeInMillis;
      const updatedStates = oauthStates.filter((item) => item.time > maxTimestamp);

      // Store the new state
      updatedStates.push(stateObject);
      oauthStates = updatedStates;
    } else {
      oauthStates = Array(stateObject);
    }
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(oauthStates));
  }

  public hasState(state: string): boolean {
    const oauthStatesItem = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!oauthStatesItem) {
      return false;
    }
    const storedStates: StateObject[] = JSON.parse(oauthStatesItem);
    return storedStates.some((item) => item.state === state);
  }

  public removeState(state: string): void {
    const oauthStatesItem = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!oauthStatesItem) {
      return;
    }
    const storedStates: StateObject[] = JSON.parse(oauthStatesItem);
    const updatedStates: StateObject[] = storedStates.filter((item) => item.state !== state);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedStates));
  }
}

interface StateObject {
  state: string;
  time: number;
}
